import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './ContactRow.scss';
import './ContactRowSkeleton.scss';

const ContactRowSkeleton = () => (
  <div className="contact-row contact-row-skeleton" aria-hidden>
    <div className="contact-row-skeleton-avatar">
      <Skeleton variant="circle" width="5rem" height="5rem" />
    </div>
    <div className="contact-row-skeleton-body">
      <div className="contact-row-skeleton-name">
        <Skeleton variant="text" width="14rem" />
      </div>
      <div className="contact-row-skeleton-role">
        <Skeleton variant="text" width="8rem" />
      </div>
    </div>
  </div>
);

export default ContactRowSkeleton;
